import { useCallback } from 'react';

import { ds } from '@/components/lib/design.system';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';

import { RaceToPlaceInfo } from '../RaceToPlaceInfo';

export const useRaceToPlaceInfoSheet = () => {
    const { showInfoSheet } = useAlerts();
    return useCallback(
        () =>
            showInfoSheet({
                backgroundColor: ds.colorValue.background.neutral.base,
                title: 'Race to Place',
                description: <RaceToPlaceInfo />,
                buttonLabel: 'Got it',
                primaryButtonTestId: 'race-to-place-info-sheet-confirm-button',
            }),
        [showInfoSheet]
    );
};
